import { Star, ExternalLink } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { GOOGLE_REVIEW_URL, REVIEWS } from "../../lib/reviews";
import { useLang } from "../../lib/i18n";

export const Reviews = () => {
    const { t } = useLang();
    if (!REVIEWS.length) return null;

    const average = REVIEWS.reduce((sum, r) => sum + r.rating, 0) / REVIEWS.length;

    return (
        <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32">
            <div className="container-x">
                <SectionHeading num="04" eyebrow={t.reviews.eyebrow} title={t.reviews.title} />
                <div className="mt-8 flex items-center gap-3" data-testid="reviews-aggregate">
                    <span className="flex gap-1 text-amber-400">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <Star key={star} size={18} fill={star <= Math.round(average) ? "currentColor" : "none"} />
                        ))}
                    </span>
                    <span className="font-mono text-sm text-slate-400">
                        {average.toFixed(1)} · {REVIEWS.length} · {t.reviews.source}
                    </span>
                </div>
                <div className="mt-10 grid gap-5 md:grid-cols-3">
                    {REVIEWS.map((review, i) => (
                        <Reveal key={i} delay={0.07 * i}>
                            <figure data-testid={`review-card-${i}`} className="card-lift h-full rounded-2xl border border-white/8 bg-night-850/80 p-7">
                                <span className="flex gap-1 text-amber-400">
                                    {[1, 2, 3, 4, 5].map((star) => (
                                        <Star key={star} size={15} fill={star <= review.rating ? "currentColor" : "none"} />
                                    ))}
                                </span>
                                <blockquote className="mt-4 text-sm leading-relaxed text-slate-300">“{review.text}”</blockquote>
                                <figcaption className="mt-5 flex items-center justify-between">
                                    <span className="text-sm font-semibold text-white">{review.name}</span>
                                    <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                                        {review.date} · {t.reviews.source}
                                    </span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
                {GOOGLE_REVIEW_URL && (
                    <Reveal delay={0.2}>
                        <a
                            href={GOOGLE_REVIEW_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="reviews-google-cta"
                            className="btn-outline mt-10 px-6 py-3.5 text-sm"
                        >
                            <ExternalLink size={16} /> {t.reviews.googleCta}
                        </a>
                    </Reveal>
                )}
            </div>
        </section>
    );
};
